import schedulesViewStateStore from "../../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction("SET_FILTER_HEADER_LABEL", function setFilterHeaderLabel(
    filterHeaderLabel: string
) {
    schedulesViewStateStore().filterHeaderLabel = filterHeaderLabel;
});
